import React from "react";
import { AuthProvider } from "react-oidc-context";
import { KEYCLOAK_CLIENT_ID, KEYCLOAK_REALM, KEYCLOAK_URL } from '@/Constants';
import userManager from "@/configs/userManager";

const oidcConfig = {
    userManager,
    authority: `${KEYCLOAK_URL}realms/${KEYCLOAK_REALM}`,
    client_id: KEYCLOAK_CLIENT_ID,
    redirect_uri: window.location.origin + "/portal",
    silent_redirect_uri: window.location.origin + "/portal/silent-redirect.html",
    scope: "openid profile email offline_access",
    response_type: "code",
    automaticSilentRenew: true,
    loadUserInfo: true,
    onSigninCallback: () => {
        // * Clean URL after redirect.
        window.history.replaceState({}, document.title, window.location.pathname);
    }
};

export const KeycloakProvider = ({ children }: { children: React.ReactNode }) => {
    return <AuthProvider {...oidcConfig}>{children}</AuthProvider>;
};